"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _serverTimeDelta["default"];
  }
});
var _serverTimeDelta = _interopRequireDefault(require("./serverTimeDelta"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }